export default __webpack_public_path__ + "static/opengraph-880f4a97c610afe5efdd28c2ae9de06a.jpg";